import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileUp, Building2, UserCog, List, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/registrations', icon: List, label: 'Registrations' },
  { to: '/assemblies', icon: Building2, label: 'Assemblies', roles: ['SUPER_ADMIN'] },
  { to: '/users', icon: UserCog, label: 'Users', roles: ['SUPER_ADMIN'] },
  { to: '/import', icon: FileUp, label: 'Import', roles: ['SUPER_ADMIN', 'AC_ADMIN'] },
];

export default function Sidebar({ open, onClose }) {
  const { user } = useAuth();

  return (
    <>
      {open && <div className="fixed inset-0 bg-black/50 z-30 md:hidden" onClick={onClose} />}
      <aside className={`fixed inset-y-0 left-0 z-40 w-64 bg-[#0f172a] text-white transform transition-transform duration-200 ${open ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0`}>
        <div className="flex items-center justify-between h-16 px-5 border-b border-white/10">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-teal-400 to-blue-500 flex items-center justify-center text-xs font-bold">YC</div>
            <span className="font-semibold text-sm">YSRCP Cadre</span>
          </div>
          <button onClick={onClose} className="md:hidden p-1"><X className="w-5 h-5" /></button>
        </div>
        <nav className="mt-4 px-3 space-y-1">
          {navItems
            .filter(item => !item.roles || item.roles.includes(user?.role))
            .map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={onClose}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors min-h-[44px] ${
                    isActive ? 'bg-teal-600/20 text-teal-400' : 'text-gray-300 hover:bg-white/5 hover:text-white'
                  }`
                }
              >
                <item.icon className="w-5 h-5 flex-shrink-0" />
                {item.label}
              </NavLink>
            ))}
        </nav>
      </aside>
    </>
  );
}
